(function () {
  'use strict';

  function syncDots(gallery, activeIndex) {
    var dots = gallery.querySelectorAll('.xm-gallery__dot');
    dots.forEach(function (d, i) {
      if (i === activeIndex) {
        d.classList.add('is-active');
      } else {
        d.classList.remove('is-active');
      }
    });
  }

  // Arrow navigation
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-xm-prev], [data-xm-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var gallery = btn.closest('[data-xm-gallery]');
    if (!gallery) return;

    gallery.classList.add('xm-gallery--manual');

    var slides = gallery.querySelectorAll('.xm-gallery__slide');
    if (slides.length < 2) return;

    if (!gallery.classList.contains('xm-gallery--synced')) {
      gallery.classList.add('xm-gallery--synced');
      var syncDefault = parseInt(gallery.getAttribute('data-default-slide') || '1', 10);
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      slides[syncDefault].classList.add('is-active');
    }

    var currentIndex = -1;
    slides.forEach(function (s, i) {
      if (s.classList.contains('is-active')) currentIndex = i;
    });

    var dir = btn.hasAttribute('data-xm-next') ? 1 : -1;
    var nextIndex = (currentIndex + dir + slides.length) % slides.length;

    slides[currentIndex].classList.remove('is-active');
    slides[nextIndex].classList.add('is-active');
    syncDots(gallery, nextIndex);
  });

  // Reset to default image when mouse leaves gallery
  document.addEventListener('mouseleave', function (e) {
    var gallery = e.target.closest('[data-xm-gallery]');
    if (!gallery) return;

    gallery.classList.remove('xm-gallery--manual');
    gallery.classList.remove('xm-gallery--synced');

    // Remove swatch preview if active
    var preview = gallery.querySelector('.xm-gallery__preview');
    if (preview) preview.remove();

    var slides = gallery.querySelectorAll('.xm-gallery__slide');
    if (slides.length < 2) return;

    var defaultIndex = parseInt(gallery.getAttribute('data-default-slide') || '1', 10);
    slides.forEach(function (s, i) {
      if (i === defaultIndex) {
        s.classList.add('is-active');
      } else {
        s.classList.remove('is-active');
      }
    });
    syncDots(gallery, defaultIndex);
  }, true);

  // Swatch hover — preview different color
  document.addEventListener('mouseenter', function (e) {
    var swatch = e.target.closest('.xm-swatch');
    if (!swatch) return;

    var imgUrl = swatch.getAttribute('data-preview-img');
    if (!imgUrl) return;

    var card = swatch.closest('.product-card');
    if (!card) return;
    var gallery = card.querySelector('[data-xm-gallery]');
    if (!gallery) return;

    var preview = gallery.querySelector('.xm-gallery__preview');
    if (!preview) {
      preview = document.createElement('div');
      preview.className = 'xm-gallery__preview';
      preview.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:5;opacity:0;transition:opacity 0.25s ease;pointer-events:none;';
      var img = document.createElement('img');
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      preview.appendChild(img);
      gallery.appendChild(preview);
    }

    preview.querySelector('img').src = imgUrl;
    preview.offsetHeight;
    preview.style.opacity = '1';
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var swatch = e.target.closest('.xm-swatch');
    if (!swatch) return;

    var card = swatch.closest('.product-card');
    if (!card) return;
    var gallery = card.querySelector('[data-xm-gallery]');
    if (!gallery) return;

    var preview = gallery.querySelector('.xm-gallery__preview');
    if (preview) preview.style.opacity = '0';
  }, true);

  // Inject line swatches from template into every product card
  function injectLineSwatches() {
    var tpl = document.getElementById('xm-line-swatches-tpl');
    if (!tpl) return;
    document.querySelectorAll('[data-line-swatches]').forEach(function (el) {
      if (el.children.length === 0) {
        el.innerHTML = tpl.innerHTML;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectLineSwatches);
  } else {
    injectLineSwatches();
  }
  document.addEventListener('collection:reloaded', injectLineSwatches);
})();
